import './Home.scss';

import React from 'react';

import HeaderHome from '../../components/header/HeaderHome';
import MainHome from '../../components/main/MainHome';

function Home() {
    return (
        <div className='container-home'>
            <HeaderHome />
            <MainHome />
        </div>
    );
}

export default Home;
